import React, { Component } from "react";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import Container from "../../../../../modules/commons/Container";
import TeamLeaderProspectReport from "./components/teamLeaderProspectReport";
import SalesmanProspectReport from "./components/salesmanProspectReport";
import FlexView from "react-flexview";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleLoadingOverlay from "../../../../../modules/popup/SimpleLoadingOverlay";
import { HttpStatus } from "../../../../common/Constants";
import { fetchDataAsync } from "../../../../../Services/Utils";
import Api from "../../../../../Services/Api";
import { mapToObjectDDL, removeNullFields } from "../../../../common/mapper";
import { monthOptions, yearOptions } from "../../config";

export default class DashboardCrmCoordinatorByTL extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      dataCabang: [],
      kodeCabang: null,
      month: null,
      year: null,
      search: {},
      doSearch: false,
      idLeader: null,
    };
  }

  componentDidMount = async () => {
    let currentDate = new Date();
    this.setState((prevValue) => ({
      ...prevValue,
      month: monthOptions.find(
        (item) => item.value === currentDate.getMonth() + 1,
      ),
      year: yearOptions.find(
        (item) => item.value === currentDate.getFullYear(),
      ),
    }));
    await this.fetchDataCabang();
    this.fetchLeaderId();
  };

  fetchLeaderId = async () => {
    let idLeader = localStorage.getItem("idLeader");
    if (idLeader) {
      this.setState((prevValue) => ({
        ...prevValue,
        idLeader: idLeader,
      }));
      return;
    }
    this.handleTriggerLoading();
    try {
      let res = await fetchDataAsync({
        asyncFn: () =>
          Api.create("NAGAMAS_MASTER_DATA").findUserById(
            this.props.auth.user.idUser,
          ),
        menuName: "Dashboard Level Team Leader - Laporan Harian By Team Leader",
        setError: this.props.setError,
      });
      if (res.ok) {
        localStorage.setItem("idLeader", res.data.data.id);
        this.setState((prevValue) => ({
          ...prevValue,
          idLeader: res.data.data.id,
        }));
      }
    } catch (error) {
      console.log("errors: ", error);
    }
    this.handleTriggerLoading();
  };

  fetchDataCabang = async () => {
    this.handleTriggerLoading();
    let res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang,
      setError: this.props.setError,
      menuName: "Dashboard Level Koordinator - Laporan Prospek Monitoring Team",
      args: null,
    });
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      let filteredData = res.data.data.filter((item) =>
        this.props.menuAccess
          .map((data) => data.idRefObj)
          .includes(item.kodeCabang),
      );

      if (filteredData.length !== 0) {
        this.setState((prevValue) => ({
          ...prevValue,
          dataCabang: filteredData,
        }));
      }
    }
    this.handleTriggerLoading();
  };

  handleTriggerLoading = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      loading: !prevValue.loading,
    }));
  };

  handleSearchValueChange = async (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      [name]: value,
    }));
  };

  handleSearch = () => {
    const { kodeCabang, teamLead, month, year } = this.state;

    this.setState((prevValue) => ({
      ...prevValue,
      search: removeNullFields({
        kodeCabangList: [kodeCabang?.value],
        month: month?.value,
        year: year?.value,
        limit: 10,
        page: 1,
      }),
      doSearch: true,
    }));
  };

  handleSuccessSearch = () => {
    this.setState({ doSearch: false });
  };

  render() {
    return (
      <div>
        <Container>
          <FlexView style={{ gap: "20px", alignItems: "center" }}>
            <SimpleDDL
              id="select_options_kode_cabang"
              box="search"
              name="kodeCabang"
              containerclassname="width width-250px"
              placeholder="Nama Cabang"
              menuPosition="fixed"
              isClearable
              options={this.state.dataCabang.map((item) =>
                mapToObjectDDL(item.namaDealer, item.kodeCabang),
              )}
              value={this.state.kodeCabang}
              onChange={(value, { name }) =>
                this.handleSearchValueChange(name, value)
              }
            />
            <SimpleDDL
              id="select_options_month"
              box="search"
              name="month"
              containerclassname="width width-250px"
              placeholder="Bulan"
              menuPosition="fixed"
              options={monthOptions}
              isClearable
              value={this.state.month}
              onChange={(value, { name }) =>
                this.handleSearchValueChange(name, value)
              }
            />
            <SimpleDDL
              id="select_options_year"
              box="search"
              name="year"
              containerclassname="width width-250px"
              placeholder="Tahun"
              menuPosition="fixed"
              isClearable
              options={yearOptions}
              value={this.state.year}
              onChange={(value, { name }) =>
                this.handleSearchValueChange(name, value)
              }
            />
            <SimpleButton onClick={this.handleSearch}>Cari</SimpleButton>
          </FlexView>
          <Tabs>
            <TabList>
              <Tab>Laporan Statistik Prospek Per TL</Tab>
              <Tab>Laporan Statistik Prospek Per Salesman / CS</Tab>
            </TabList>
            <TabPanel>
              <TeamLeaderProspectReport
                {...this.props}
                search={this.state.search}
                doSearch={this.state.doSearch}
                onSearchValueChange={this.handleSearchValueChange}
                triggerLoading={this.handleTriggerLoading}
                onSuccessSearch={this.handleSuccessSearch}
                idLeader={this.state.idLeader}
              />
            </TabPanel>
            <TabPanel>
              <SalesmanProspectReport
                {...this.props}
                search={this.state.search}
                doSearch={this.state.doSearch}
                onSearchValueChange={this.handleSearchValueChange}
                triggerLoading={this.handleTriggerLoading}
                onSuccessSearch={this.handleSuccessSearch}
                idLeader={this.state.idLeader}
              />
            </TabPanel>
          </Tabs>
          {this.state.loading && (
            <SimpleLoadingOverlay active={this.state.loading} />
          )}
        </Container>
      </div>
    );
  }
}
